import FuseSearch from '@fuse/core/FuseSearch';
import FuseShortcuts from '@fuse/core/FuseShortcuts';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import NavbarToggleButton from 'app/fuse-layouts/shared-components/NavbarToggleButton';
import QuickPanelToggleButton from 'app/fuse-layouts/shared-components/quickPanel/QuickPanelToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import clsx from 'clsx';
import { memo , useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectToolbarTheme } from 'app/store/fuse/settingsSlice';

import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import useRouter from '@fuse/hooks/useRouter';
import axiosgeneral from "@fuse/utils/axios";
import NotificationMenu from 'app/fuse-layouts/shared-components/NotificationMenu';
import QuickActionTable from '../../shared-components/QuickAction'
import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
import AdjustFontSize from '../../shared-components/AdjustFontSize';
import Search from '../../shared-components/header'

const useStyles = makeStyles(theme => ({
	root: {}
}));

function EmailIconButton(props) {
	return (
		<Tooltip title="Emails" placement="bottom">
			<IconButton onClick={() => { }} className={clsx('w-40 h-40', props.className)}>
				<Icon>email</Icon>
			</IconButton>
		</Tooltip>
	)
}

function ToolbarLayout1(props) {
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const navbar = useSelector(({ fuse }) => fuse.navbar);
	const { title: pageTitle } = useSelector(({ fuse }) => fuse.pageTitle);
	const toolbarTheme = useSelector(selectToolbarTheme);
	const classes = useStyles(props);


	const [currentSuggestions, setCurrentSuggestions] = useState([]);
	const [ currentSuggestionsIdData,  setCurrentSuggestionsIdData ] = useState({})
	const [currentSearch, setCurrentSearch] = useState('');
	const [assetId, setAssetId] = useState({})

	const router = useRouter();

	function onSearch() {
		if (!currentSearch) {
			setCurrentSearch('');
			return
		}
		// console.log('61: ',currentSearch,assetId,assetId[currentSearch].id);
		// router.push(`asset-infos/detail/${assetId[currentSearch].id}`)
		router.push(`/assets-list/${currentSearch}`)
		setCurrentSearch('')
	}

	function clearSearch() {
		// setPage(0);
		// setCurrentFilter(0);
		setCurrentSuggestions([]);
		setCurrentSuggestionsIdData({})
		setCurrentSearch('')
		// fetchAssets();
	}

	function onSelectSuggestion(val) {
		setCurrentSearch(currentSuggestions[val]);
	}

	function onSelectSuggestionRaw(val) {
		setCurrentSearch(val);
	}

	useEffect(() => {
		// console.log('serial_id =============', router.query?.serial_id)
		// // if (router.location.pathname !== '/dashboard') return
		// const filter = 'Serial Number';
		// let suggestions = [];
		// axiosgeneral.get(`/assets/fetch-suggestions?filter=${filter}`)
		// 	.then(res => {
		// 		suggestions = Array.from(new Set(res.data.data.suggestions));
		// 		setAssetId(res.data.data.map_serial_number_with_asset_id)
		// 		if (suggestions.length === 1 && suggestions[0] === '') {
		// 			suggestions = [];
		// 		}
		// 		setCurrentSearch('');
		// 		if(router.query?.serial_id !== undefined) {
		// 			console.log('sujay ghosh', suggestions)
		// 		}
		// 		setCurrentSuggestions(suggestions);
		// 		if(res.data.data.map_serial_number_with_asset_id !== undefined) {
		// 			setCurrentSuggestionsIdData(res.data.data.map_serial_number_with_asset_id);
		// 		}
				
		// 	})
		// 	.catch(err => {
		// 		return err;
		// 	})
	}, [router.location.pathname]);

	return (
		<ThemeProvider theme={toolbarTheme}>
			<AppBar
				id="fuse-toolbar header_toolbar"
				className={clsx(classes.root, 'flex relative z-20', props.className)}
				color="default"
				style={{ backgroundColor: toolbarTheme.palette.background.paper, boxShadow:'none' }}
				position="static"
			>
				<Toolbar className="p-0 header_toolbarHeight">
					<div className="flex" style={{ alignItems: "center", paddingLeft: '24px', paddingRight: '28px' }}>
						{/* {config.navbar.display && config.navbar.position === 'left' && (
							<>
								<Hidden mdDown>
									{(config.navbar.style === 'style-3' || config.navbar.style === 'style-3-dense') && (
										<NavbarToggleButton className="w-40 h-40 p-0 mx-0" />
									)}

									{config.navbar.style === 'style-1' && !navbar.open && (
										<NavbarToggleButton className="w-40 h-40 p-0 mx-0" />
									)}
								</Hidden>

								<Hidden lgUp>
									<NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
								</Hidden>
							</>
						)} */}

						{/* <Hidden mdDown>
							<FuseShortcuts />
						</Hidden> */}
						<div>
							{pageTitle}
						</div>
						{/* {router.location.pathname === '/dashboard' &&  */}
						<Search
							search={onSearch}
							clearSearch={clearSearch}
							onSelectSuggestion={onSelectSuggestion}
							onSelectSuggestionRaw={onSelectSuggestionRaw}
							currentSuggestionsIdData={currentSuggestionsIdData}
							currentSearch={currentSearch}
							currentSuggestions={currentSuggestions}
						/>
					</div>

					<div style={{padding: '4px 28px'}} className="flex items-center overflow-x-auto overflow-y-hidden">
						{/* <LanguageSwitcher /> */}

						{/* <AdjustFontSize /> */}

						{/* <NotificationMenu />
						
						<EmailIconButton /> */}

						{/* <FullScreenToggle /> */}
						<QuickActionTable />
						{/* <span className='notification_icon'>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fillRule="evenodd" clipRule="evenodd" d="M14.1277 4.4115C13.3108 4.08333 12.4291 3.94852 11.5515 4.01761C10.6739 4.08671 9.82416 4.35783 9.06871 4.80979C8.31326 5.26175 7.67257 5.8823 7.19672 6.62294C6.72087 7.36357 6.42276 8.20423 6.32568 9.07918L6.10725 11.0433L6.10205 11.0901C6.00427 11.9425 5.72686 12.7643 5.28813 13.5016L5.26386 13.5423L4.76285 14.377L4.74205 14.4117C4.53228 14.761 4.34332 15.0774 4.21677 15.3452C4.08848 15.6174 3.95066 15.9867 4.01741 16.4062C4.08251 16.82 4.29528 17.1963 4.61636 17.4654C4.94228 17.7376 5.32887 17.8095 5.62878 17.8399C5.92349 17.8693 6.29274 17.8693 6.69927 17.8693H17.3002C17.7067 17.8693 18.0751 17.8693 18.3706 17.8399C18.6697 17.8095 19.0571 17.7376 19.3822 17.4654C19.7036 17.1965 19.9167 16.8202 19.982 16.4062C20.0488 15.9875 19.9109 15.6174 19.7827 15.3452C19.6561 15.0765 19.4671 14.761 19.2574 14.4117L19.2366 14.377L18.7356 13.5423L18.7113 13.5016C18.3836 12.9511 18.1452 12.3523 18.0049 11.7272C17.4179 11.8374 16.8145 11.8256 16.2323 11.6926C16.3923 12.6446 16.7277 13.5586 17.2213 14.3883L17.249 14.4342L17.75 15.269C17.9867 15.6642 18.1297 15.9043 18.2146 16.0837L18.2268 16.1115C18.2167 16.1127 18.2065 16.1139 18.1964 16.1149C17.9997 16.1349 17.7197 16.1358 17.2594 16.1358H6.74001C6.27974 16.1358 5.99976 16.1349 5.80213 16.1149C5.7923 16.1139 5.78248 16.1127 5.77266 16.1115L5.7848 16.0837C5.86974 15.9043 6.01277 15.6642 6.2494 15.269L6.75041 14.4342L6.77814 14.3883C7.34216 13.4404 7.69874 12.3836 7.82436 11.2878L7.83043 11.2358L8.04886 9.27074C8.11322 8.69035 8.30466 8.13127 8.60956 7.63324C8.91447 7.13522 9.32535 6.71049 9.813 6.38925C10.3007 6.06801 10.8531 5.85816 11.431 5.77461C12.009 5.69106 12.5982 5.73587 13.1569 5.90585C13.3736 5.34591 13.7041 4.83706 14.1277 4.4115ZM16.3181 5.97519C16.0046 6.16051 15.7574 6.43986 15.6116 6.7736C15.4658 7.10735 15.4288 7.47852 15.5059 7.83447C15.6099 8.0295 15.6983 8.23406 15.7703 8.44729C15.9758 8.74818 16.271 8.97658 16.6138 9.09999C16.9566 9.2234 17.3297 9.23553 17.6798 9.13466L17.6737 9.07918C17.5474 7.93089 17.0746 6.84824 16.3181 5.97519Z" fill="#1D2939" stroke="white" strokeWidth="0.2" />
								<path d="M9.48779 17.5789C9.63601 18.4084 9.9628 19.1408 10.417 19.6635C10.8712 20.1862 11.4277 20.4696 11.9998 20.4696C12.5718 20.4696 13.1283 20.1862 13.5825 19.6635C14.0367 19.1408 14.3626 18.4084 14.5117 17.5789" stroke="#1D2939" strokeWidth="1.5" strokeLinecap="round" />
								<path d="M17.2012 9.63487C18.398 9.63487 19.3681 8.66468 19.3681 7.46789C19.3681 6.2711 18.398 5.3009 17.2012 5.3009C16.0044 5.3009 15.0342 6.2711 15.0342 7.46789C15.0342 8.66468 16.0044 9.63487 17.2012 9.63487Z" fill="#1D2939" stroke="#1D2939" strokeWidth="0.866794" />
							</svg>
						</span> */}

						<NotificationMenu />

						{/* <FuseSearch /> */}

						{/* <QuickPanelToggleButton /> */}

						<UserMenu />
					</div>

					{config.navbar.display && config.navbar.position === 'right' && (
						<>
							<Hidden mdDown>
								{!navbar.open && <NavbarToggleButton className="w-40 h-40 p-0 mx-0" />}
							</Hidden>

							<Hidden lgUp>
								<NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
							</Hidden>
						</>
					)}
				</Toolbar>
			</AppBar>
		</ThemeProvider>
	);
}

export default memo(ToolbarLayout1);
